var $ce77af30fc9a6e63$exports = {};
document.addEventListener('DOMContentLoaded', function(e) {
    const contactOpener = document.querySelector('.contact-opener');
    contactOpener?.addEventListener('click', function(e) {
        e.preventDefault();
        document.body.classList.toggle('opened-contact');
    });
});


//# sourceMappingURL=index.c94d6a0e.js.map
